import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

// The active employer lets its admins and record viewers read the litterat of
// projects where its employees work (the admin calendars).
export const getActiveProjectAssignments = async (
  projectId,
  activeEmployerBusinessId
) => {
  const apiPath = `projects/${projectId}/active-assignments`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
    ...(activeEmployerBusinessId && {
      headers: { 'X-Active-Employer-Business-Id': activeEmployerBusinessId },
    }),
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
